import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import { ButtonGroup } from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/styled-components'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import {
  selectAddressesConfigData,
  selectClientTabHasUnsavedChanges,
  selectContactConfig,
  selectCurrentAddressData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'

/**
 * Single "Save" button that orchestrates the four client-tab saves at once
 * (contact, address, electricity meter, gas meter). Replaces the four legacy
 * per-module save buttons. Mirrors the layout/positioning of the contracts
 * SaveButtons in TopHeader.
 */
const ClientSaveButtons = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { isEditable } = useFormStatus()

  const { isSaving: contactIsSaving } = useSelector(selectContactConfig)
  const { addressIsSaving } = useSelector(selectAddressesConfigData)
  const { electricityMeter = {}, gasMeter = {} } = useSelector(selectCurrentAddressData)
  const hasUnsavedChanges = useSelector(selectClientTabHasUnsavedChanges)

  const isAnyModuleSaving =
    !!contactIsSaving || !!addressIsSaving || !!electricityMeter.isSaving || !!gasMeter.isSaving

  // Same gating as the contract SaveButtons: form must be editable, no save in
  // flight, and there must be something to save.
  const disabled = !isEditable || isAnyModuleSaving || !hasUnsavedChanges

  const handleSaveAll = () => {
    dispatch({
      type: subscriptionFormActionsV2.CLIENT_TAB_SAVE_ALL,
      enqueue,
    })
  }

  return (
    <ButtonGroup>
      <SDButton disabled={disabled} isLoading={isAnyModuleSaving} onClick={handleSaveAll}>
        {t('subscriptionForm:client_tab.save_all')}
      </SDButton>
    </ButtonGroup>
  )
}

export default ClientSaveButtons
